(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function throttle(func, wait, options) {
  /* options的默认值
   *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
   *  options.leading = true;
   * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
   *  options.trailing = true; 
   * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
   */
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    // 计算剩余时间
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    // 当到达wait指定的时间间隔，则调用func函数
    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}
;
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}
function hasHorizontalScrollbar(selector) {
  var div = $(selector)[0]; // 获取 DOM 元素
  return div.scrollWidth > div.clientWidth;
}
var addMask = debounce(function () {
  if (hasHorizontalScrollbar('.crumbs .pad')) {
    $('.crumbs').addClass('show-mask');
  } else {
    $('.crumbs').removeClass('show-mask');
  }
}, 200);
if ($('.crumbs').length) {
  $('.crumbs .pad').scrollCenter('.current');
  $(window).resize(function () {
    addMask();
  }).resize();
}

},{}],2:[function(require,module,exports){
"use strict";

;
(function () {
  var $btn = $('#go-top');
  $(window).scroll(function (event) {
    if ($(window).scrollTop() >= $(window).height() / 2) {
      $btn.addClass('show');
    } else {
      $btn.removeClass('show');
    }
  }).scroll();
  $btn.click(function () {
    $('body,html').stop().animate({
      scrollTop: 0
    }, 500);
    return false;
  });
})();

},{}],3:[function(require,module,exports){
"use strict";

var $pushmenu;
$(".m_nav").pushmenu({
  button: "#nav_toggle"
});
$pushmenu = $('.m_nav').data('pushmenu');
$("#m-nav li").each(function () {
  var sub = $(this).find(".sub-menu");
  var link = sub.find("a").length > 0;
  if (sub && link) {
    $(this).addClass("has-sub");
    $(this).children("a").append('<i class="iconfont icon-db-arrow"></i>');
  }
});
$(".m-nav-list > li > a").click(function () {
  var sub = $(this).next(".sub-menu");
  if (!$(this).parents("li").hasClass("has-sub")) {
    return true;
  }
  if (sub.is(":visible")) {
    sub.slideUp();
    $(this).removeClass("on");
  } else {
    $("#m-nav .sub-menu").slideUp();
    $("#m-nav li .on").removeClass("on");
    $(this).addClass("on");
    sub.slideDown();
  }
  return false;
});

// 锚点点击关闭mask
$('#m-nav .sub-menu a').click(function (e) {
  if (this.hash && $(this.hash).length > 0) {
    var offset = $('.m_header').height();
    var Scroll = $(this.hash).offset().top - offset;
    $('html,body').stop(false, true).animate({
      'scrollTop': Scroll + 'px'
    }, 400);
    $('#nav_toggle').click();
  }
});
$('.sub-menu').each(function () {
  $(this).find('li').each(function () {
    var $third = $(this).find('.m-third-nav');
    if ($third.length) {
      $(this).children('a').append('<i class="iconfont icon-down"></i>');
      $(this).addClass('have-third');
    }
  });
});
$(".sub-menu li > a").click(function () {
  var sub = $(this).next(".m-third-nav");
  if (!$(this).parents("li").hasClass("have-third")) {
    return true;
  }
  if (sub.is(":visible")) {
    sub.slideUp();
    $(this).removeClass("on");
  } else {
    $("#m-nav .m-third-nav").slideUp();
    // $("#m-nav li .on").removeClass("on")
    $(this).addClass("on");
    sub.slideDown();
  }
  return false;
});

/*$("#m-nav .sub-nav a").click(function () {
    $pushmenu.hideMenu();
});
*/

},{}],4:[function(require,module,exports){
"use strict";

require("./_m-nav.js");
require("./_go-top.js");
require("./_breadcrumbs.js");

},{"./_breadcrumbs.js":1,"./_go-top.js":2,"./_m-nav.js":3}]},{},[4]);
